import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { NavService } from '../_services/NavService.service';
import { appService } from '../_services/app.service';
import { CommonService } from '../_services/common.service';
import { DecryptPipe } from '../auth/_services/encrypt-decrypt.pipe';
import { TranslateConfigService } from '../theme/home/translateConfig.service';
import { environment } from '../../environments/environment';
const LNG_KEY = "SELECTED_LANGUAGE";

declare var $: any;
declare var moment: any;

@Component({
  selector: 'app-trip-expense',
  templateUrl: './trip-expense.component.html',
  styleUrls: ['./trip-expense.component.scss']
})
export class TripExpenseComponent implements OnInit {
  transporterId: any;
  transportname: any;
  Deleteright: any;
  editright: any;
  //add by maaria
  isAdvance: any = false;
  ChargeObj: any = {};
  THCChargeList: any = [];
  selectedLang: string;
  static tripExpenseComponent: TripExpenseComponent;
  THCChargeListDefalut: any = {};
  UserId: any;
  TenantId: any;
  CompanyId: any;
  SelectedCompanyGSTCode: any;
  isHideFooter: boolean = false;
  GSTType: any;
  TransporterId: any;
  THCId: any;
  totalChargeAmount: any = 0;
  THCChargeRemark: any = '';
  totalAdvance: any = 0;
  IsAdvanceChargeCode: any = false;

  constructor(
    private _appService: appService,
    private commonService: CommonService,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private _navService: NavService,
    private cookieservice: CookieService,
    private router: Router,
    private service: TranslateConfigService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe
  ) {
    TripExpenseComponent.tripExpenseComponent = this;

    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    // this.getChargeList();
    console.log('TransporterIdVartrip:', this.transporterId);
    this.Deleteright = this.commonService.CheckHasRight("DELETE", "TRIP_EXPENSE")
    this.editright = this.commonService.CheckHasRight('EDIT', 'TRIP_EXPENSE')
    console.log(this.editright, 'editright right')
  }

  ngAfterViewInit() {
    this.getChargeList();
  }

  PopChangeData() {
    if (
      this.ChargeObj.Discount == "undefined" ||
      this.ChargeObj.Discount == null
    ) {
      this.ChargeObj.Discount = 0;
    } else {
      this.ChargeObj.Discount = parseFloat(this.ChargeObj.Discount.toFixed(2));
    }
    if (this.ChargeObj.Rate == "undefined" || this.ChargeObj.Rate == null) {
      this.ChargeObj.Rate = 0;
    } else {
      this.ChargeObj.Rate = parseFloat(this.ChargeObj.Rate.toFixed(2));
    }
    if (
      this.ChargeObj.Quantity == "undefined" ||
      this.ChargeObj.Quantity == null
    ) {
      this.ChargeObj.Quantity = 0;
    } else {
      this.ChargeObj.Quantity = parseFloat(parseFloat(this.ChargeObj.Quantity).toFixed(2));
    }
    this.ChargeObj.Amount = this.ChargeObj.Rate * this.ChargeObj.Quantity - this.ChargeObj.Discount;
    this.ChargeObj.Amount = parseFloat(this.ChargeObj.Amount.toFixed(2));

    if (this.IsAdvanceChargeCode) {
      this.ChargeObj.Advance = this.ChargeObj.Amount;
    }

    //add by maaria
    if (this.ChargeObj.Advance == "undefined" || this.ChargeObj.Advance == null) {
      this.ChargeObj.Advance = 0;
    } else {
      if (this.ChargeObj.Advance > this.ChargeObj.Amount) {
        this.isAdvance = true;
      }
      else {
        this.isAdvance = false;
        this.ChargeObj.Advance = parseFloat(this.ChargeObj.Advance.toFixed(2));
      }

    }
    //end
  }

  addChargeinAmount(isEdit) {
    if (!this.commonService.ValidateRequiredField2($("#Charges"), $("#FieldSetCharge"),
      "Please Select Charge",
      "after", "")
    ) {
      return false;
    }
    if (!this.commonService.ValidateRequiredField2($("#se2_Vendor"), $("#FieFieldSetse2_VendorldSetCharge"),
      "Please Select Vendor",
      "after", "")
    ) {
      return false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#BasedOn"),
        "Please Select Based On",
        "after",
        ""
      )
    ) {
      return false;
    }
    if (this.ChargeObj.Amount != 0) {
      if (isEdit == 'true') {
        this.THCChargeList[this.ChargeObj.index].VendorId = $("#se2_Vendor").val();
        this.THCChargeList[this.ChargeObj.index].VendorName = $("#se2_Vendor option:selected").text().trim();
        this.THCChargeList[this.ChargeObj.index].chrgerCode = $("#Charges option:selected").text().trim();
        this.THCChargeList[this.ChargeObj.index].Unit = this.ChargeObj.BasedOn;
        this.THCChargeList[this.ChargeObj.index].Qty = this.ChargeObj.Quantity;
        this.THCChargeList[this.ChargeObj.index].Rate = this.ChargeObj.Rate;
        this.THCChargeList[this.ChargeObj.index].totalAmount = this.ChargeObj.Amount;
        this.THCChargeList[this.ChargeObj.index].Advance = this.ChargeObj.Advance;
        //added by vithujan 06-04-2023
        this.THCChargeList[this.ChargeObj.index].DeductFromAdvance = $("#DeductFromAdvance").is(":checked");
        //end
      } else {
        var obj: any = {};
        obj.VendorId = $("#se2_Vendor").val();
        obj.VendorName = $("#se2_Vendor option:selected").text().trim();
        obj.chrgerCode = $("#Charges option:selected").text().trim();
        obj.Unit = this.ChargeObj.BasedOn;
        obj.Qty = this.ChargeObj.Quantity;
        obj.Rate = this.ChargeObj.Rate;
        obj.totalAmount = this.ChargeObj.Amount;
        obj.Advance = this.ChargeObj.Advance;
        obj.ContractAmount = 0;
        obj.IsContracted = 'false';
        //added by vithujan 06-04-2023
        obj.DeductFromAdvance = $("#DeductFromAdvance").is(":checked");
        //end
        this.THCChargeList.push(obj);
      }
      this.IsAdvanceChargeCode = false;
      this.totalChargeAmount = 0;
      this.totalAdvance = 0;
      this.THCChargeList.forEach(element => {
        this.totalChargeAmount = this.totalChargeAmount + element.totalAmount;
        this.totalAdvance = this.totalAdvance + element.Advance;
      });
      $("#BasedOn").val("");
      setTimeout(() => {
        (<any>$("#BasedOn")).selectpicker("refresh");
      }, 200);
      $("#se2_Vendor").val("");
      $("#se2_Vendor").select2("destroy");
      $("#Charges").val("");
      $("#Charges").select2("destroy");
      this.getChargeList();
      this.ChargeObj = {};
      this.ChargeObj.Amount = 0;
      this.ChargeObj.isEdit = 'false';
      //added by vithujan 07-04-2023
      this.ChargeObj.DeductFromAdvance = false;
      //end
    } else {
      this.toastr.error("Amount is zero !", "error");
    }
  }

  getChargeList() {
    console.log(TripExpenseComponent.tripExpenseComponent.THCChargeListDefalut);
    $("#Charges").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/GetChargeForAccouting",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            ChargeType: 'Charge',
            GSTType: TripExpenseComponent.tripExpenseComponent.GSTType,
            TransporterId: TripExpenseComponent.tripExpenseComponent.TransporterId,
            THCId: TripExpenseComponent.tripExpenseComponent.THCId,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],
      placeholder: "Search for Charges",
    });


    // $("#Charges").select2({
    //   width: "100%",
    //   escapeMarkup: function (markup) {
    //     return markup;
    //   },
    //   minimumInputLength: 2,
    //   ajax: {
    //     global: false,
    //     url: environment.apiUrl + "api/Bills/GetChargeForAccouting",
    //     delay: 300,
    //     dataType: "json",
    //     allowClear: true,
    //     data: function (params) {
    //       return {
    //         query: params.term,
    //         page: params.page || 1,
    //         ChargeType: 'Charge',
    //         GSTType: 'Inter',
    //         TransporterId: null,
    //         THCId: null,
    //       };
    //     },
    //     processResults: function (data, params) {
    //       params.page = params.page || 1;
    //       return {
    //         results: data.Results,
    //         pagination: {
    //           more: params.page * 30 < data.Total,
    //         },
    //       };
    //     },
    //   },
    //   tokenSeparators: [",", " "],
    //   placeholder: "Search for Charges",
    // });

    $("#Charges").on("select2:select", function (e) {
      var data = e.params.data;
      if (data.text == 'Trip Advance To Driver') {
        TripExpenseComponent.tripExpenseComponent.IsAdvanceChargeCode = true;
      } else {
        TripExpenseComponent.tripExpenseComponent.IsAdvanceChargeCode = false;
      }
    });

    $("#se2_Vendor").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Booking/td_getTripExpenseVendor",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: TripExpenseComponent.tripExpenseComponent.CompanyId,
            param1: params.term,
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for Vendor",
    });

    $("#se2_Vendor").on("select2:select", function (e) {
      var data = e.params.data;
      // TripDocumentPrintComponent.tripDocumentPrintComponent.deliveryno = data.id;
    });
  }

  DeleteCharge(index) {
    swal({
      title: "Are you sure?",
      text:
        "You won't be able to revert this!",
      type: "warning",
      showCancelButton: !0,
      confirmButtonText: "Yes, delete it!",
    }).then(function (e) {
      TripExpenseComponent.tripExpenseComponent.THCChargeList.splice(index, 1);
      this.totalChargeAmount = 0;
      this.totalAdvance = 0;
      this.THCChargeList.forEach(element => {
        this.totalChargeAmount = this.totalChargeAmount + element.totalAmount;
        this.totalAdvance = this.totalAdvance + element.Advance;
      });
    });
  }

  EditCharge(index) {
    var vendorOption = '<option value="' + this.THCChargeList[index].VendorId + '">' + this.THCChargeList[index].VendorName; + '</option>';
    $("#se2_Vendor").html(vendorOption);
    var chargeOption = '<option value="' + this.THCChargeList[index].chrgerCode + '">' + this.THCChargeList[index].chrgerCode; + '</option>';
    $("#Charges").html(chargeOption);
    this.ChargeObj.BasedOn = this.THCChargeList[index].Unit;
    this.ChargeObj.Quantity = this.THCChargeList[index].Qty;
    this.ChargeObj.Rate = this.THCChargeList[index].Rate;
    this.ChargeObj.Amount = this.THCChargeList[index].totalAmount;
    this.ChargeObj.Advance = this.THCChargeList[index].Advance;
    this.ChargeObj.isEdit = 'true';
    this.ChargeObj.index = index;
    //added by vithujan 07-04-2023
    this.ChargeObj.DeductFromAdvance = this.THCChargeList[index].DeductFromAdvance;
    //end
    if (this.THCChargeList[index].chrgerCode == 'Trip Advance To Driver') {
      this.IsAdvanceChargeCode = true;
    } else {
      this.IsAdvanceChargeCode = false;
    }
    setTimeout(() => {
      (<any>$("#BasedOn")).selectpicker("refresh");
    }, 200);
  }
  //added by rahul
  FetchDefaultTransporter() {
    var Tranporter = "";
    Tranporter += '<option value="' + this.transporterId + '">' + this.transportname + "</option>";
    $("#se2_Vendor").html(Tranporter);
    $("#se2_Vendor").val(this.transporterId).change();
  }
  //end
}
